<script>
  import SectionHeader from '../components/SectionHeader.svelte';
  import ResidentFilter from '../components/ResidentFilter.svelte';
  import AlertTable from '../components/AlertTable.svelte';
  import SendAlert from '../components/SendAlert.svelte';
  import { AppController } from '../AppController';
  import { showLoading } from '../components/Overlay.svelte';
  import { stickyToast } from '../components/Toast.svelte';
  import { fade } from 'svelte/transition';
  import { onMount } from 'svelte';

  onMount(async () => {
    try {
      showLoading(true);
      await AppController.getResidents();
    } catch(e) {
      console.log(e);
      stickyToast('danger', 'Error', 'An error occured while retrieving residents.');
    } finally {
      showLoading(false);
    }
  });
</script>

<div in:fade="{{duration: 1000}}">
  <SectionHeader section='Alerts' subsection='Create Alert'>
  </SectionHeader>
  <ResidentFilter></ResidentFilter>
  <AlertTable></AlertTable>
  <SendAlert></SendAlert>
</div>